module.exports = __webpack_public_path__ + "img/thumbnail_BactrianCamel_f_normal.a635f7a3.png";